export class ForecastRun {
  id: string;
  forecastId: string;
}
